// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Qz-z","tooltipWrapper":"Rz-z","icon":"Sz-z","tooltip":"Tz-z","content":"Uz-z"};